import { c as _c } from "react/compiler-runtime";
import { IcoCloseSmall16, IcoText16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import { useRef } from 'react';
import type { NormalizedArtifact } from '../onboarding-data-entry-viewer';
import { getArtifactId } from '../onboarding-data-entry-viewer';
import { getFileArtifactIcon } from '../utils/file-artifacts-utils';
type TabBarProps = {
  tabs: NormalizedArtifact[];
  activeTab: NormalizedArtifact | null;
  onSelectTab: (artifact: NormalizedArtifact) => void;
  onCloseTab: (artifact: NormalizedArtifact) => void;
};
function isInView(el: HTMLElement) {
  const rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
const TabBar = t0 => {
  const $ = _c(12);
  const {
    tabs,
    activeTab,
    onSelectTab,
    onCloseTab
  } = t0;
  const containerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = node => {
      if (!containerRef.current || !isInView(containerRef.current)) {
        return;
      }
      node?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest"
      });
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const activeTabRef = t1;
  if (tabs.length === 0) {
    return null;
  }
  let t2;
  if ($[1] !== activeTab || $[2] !== onCloseTab || $[3] !== onSelectTab || $[4] !== tabs) {
    let t3;
    if ($[6] !== activeTab || $[7] !== onCloseTab || $[8] !== onSelectTab) {
      t3 = tab => {
        const isActive = activeTab ? getArtifactId(tab) === getArtifactId(activeTab) : false;
        const Icon = tab.artifactType === "file" ? getFileArtifactIcon(tab) : IcoText16;
        return <button key={getArtifactId(tab)} ref={isActive ? activeTabRef : undefined} type="button" className={cx("group flex items-center gap-1.5 px-3 py-2 cursor-pointer border-r border-tertiary select-none text-left", {
          "bg-primary border-b-2 border-b-accent": isActive,
          "hover:bg-hover": !isActive
        })} onClick={() => onSelectTab(tab)}><Icon className={cx("shrink-0", {
            "text-primary": isActive,
            "text-tertiary": !isActive
          })} /><span className={cx("whitespace-nowrap text-caption-1", {
            "text-primary": isActive,
            "text-tertiary": !isActive
          })}>{tab.key}</span><span role="button" tabIndex={0} className={cx("shrink-0 rounded-sm p-0.5 transition-colors", "md:opacity-0 group-hover:opacity-100", {
            "md:opacity-100": isActive
          }, "hover:bg-hover")} onClick={e => {
            e.stopPropagation();
            onCloseTab(tab);
          }} onKeyDown={e_0 => {
            if (e_0.key === "Enter" || e_0.key === " ") {
              e_0.stopPropagation();
              onCloseTab(tab);
            }
          }} aria-label={`Close ${tab.key}`}><IcoCloseSmall16 className="text-tertiary" /></span></button>;
      };
      $[6] = activeTab;
      $[7] = onCloseTab;
      $[8] = onSelectTab;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = tabs.map(t3);
    $[1] = activeTab;
    $[2] = onCloseTab;
    $[3] = onSelectTab;
    $[4] = tabs;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[10] !== t2) {
    t3 = <div ref={containerRef} className="flex border-b border-tertiary bg-secondary overflow-x-auto shrink-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">{t2}</div>;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default TabBar;